import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { Controller, useForm } from "react-hook-form";
import Swal from "sweetalert2";
import {
    useAPIQuery,
    useGlobalAPIQueryContext,
} from "@dev2_techwalnut/tw-api-query-hook";
import Select from "react-select";
import secureLocalStorage from "react-secure-storage";
import { VARIABLES } from "../../../Constant";

const CreateTypeMaster = () => {
    const userID = secureLocalStorage.getItem("userID");
    const delay_time = VARIABLES.delayTime;
    const navigate = useNavigate();

    const { invalidateApi } = useGlobalAPIQueryContext();

    const [categoryData, setCategoryData] = useState([]);
    const [typeMasterCategory, setTypeMasterCategory] = useState(null);

    const { useFetch } = useAPIQuery({
        key: "api/generic",
        endpoint: "/api/generic/",
    });

    const { data, isLoading } = useFetch({
        abortOnNewRequest: true,
        refetchOnWindowFocus: false,
        staleTime: 1000 * 60 * 3,
        retry: 3,
        keepPlaceholder: true,
        refetchOnReconnect: true,
    });

    const { useCreate } = useAPIQuery({
        key: "api/type-master",
        endpoint: "/api/type-master/",
    });

    const handleCreateTypeMaster = (data) => {
        Swal.fire({
            title: "Type Master Added!",
            text: data.message,
            icon: "success",
        }).then((result) => {
            if (result.isConfirmed) {
                invalidateApi({ key: ["api/generic"] });
                setTimeout(() => {
                    navigate(-1);
                }, 2000);
            }
        });
    };

    const handleErrorTypeMaster = (data) => {
        Swal.fire({
            title: "Error Adding Type Master",
            text: data?.data?.data?.message,
            icon: "error",
        });
    };

    const { mutate, isPending } = useCreate({
        onSuccess: handleCreateTypeMaster,
        onError: handleErrorTypeMaster,
        retry: 2,
    });

    // react Hook form Props
    const {
        register,
        handleSubmit,
        formState: { errors },
        control,
        reset,
    } = useForm();

    // onSubmit handler to post form details
    const onSubmit = (data) => {
        var type_master = {
            name: data.name,
            value: data.value,
            category_id: typeMasterCategory?.id,
            sequence: data.sequence,
            description: data.description,
            created_by: userID,
            updated_by: userID,
        };

        mutate({
            data: type_master,
        });
    };

    useEffect(() => {
        if (data) {
            setCategoryData(data.category);
        }
    }, [data]);

    useEffect(() => {
        const category = JSON.parse(sessionStorage.getItem("TMCategory"));
        if (category) {
            setTypeMasterCategory(category);
        }
    }, []);

    if (!JSON.parse(sessionStorage.getItem("TMCategory"))) {
        Swal.fire({
            icon: "error",
            text: "Unable to find category",
        }).then(() => navigate(-1));
    }

    return (
        <>
            <div className="nk-block-head nk-block-head-sm">
                <div className="nk-block-between">
                    <div className="nk-block-head-content">
                        <h4 className="nk-block-title"> Create Type Master </h4>
                    </div>
                </div>
            </div>
            <div className="col-lg-12 col-md-12 col-sm-12">
                <div class="card">
                    <div class="card-inner">
                        {/* For Form : Use React hook forms */}
                        <form
                            onSubmit={handleSubmit(onSubmit)}
                            autoComplete="off"
                        >
                            <div className="row g-4">
                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Type Master Display Name
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter Type Master Display Name"
                                        id="text-forms-name"
                                        {...register("name", {
                                            required: true,
                                        })}
                                    />
                                    {errors.name && (
                                        <span className="fs-8 text-danger">
                                            Type Master Display Name is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Type Master Name
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter type master name"
                                        id="email-forms-value"
                                        {...register("value", {
                                            required: true,
                                        })}
                                    />
                                    {errors.value && (
                                        <span className="fs-8 text-danger">
                                            Type Master Value is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Type Master Category
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter type master category"
                                        id="text-forms-value"
                                        defaultValue={
                                            typeMasterCategory?.category_name
                                        }
                                        readOnly
                                    />
                                </div>

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Sequence
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <input
                                        type="text"
                                        className="form-control"
                                        placeholder="Enter sequence"
                                        id="text-sequence"
                                        {...register("sequence", {
                                            required: true,
                                        })}
                                    />
                                    {errors.sequence && (
                                        <span className="fs-8 text-danger">
                                            Sequence is required
                                        </span>
                                    )}
                                </div>

                                {/* <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Type Master Category
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <Controller
                                        render={({ field }) => (
                                            <Select
                                                {...field}
                                                options={categoryData?.map(
                                                    (info) => ({
                                                        value: info.id,
                                                        label: info.category_name,
                                                    })
                                                )}
                                                isLoading={isLoading}
                                                isClearable={true}
                                                id="select-forms-typemaster-category"
                                            />
                                        )}
                                        defaultValue=""
                                        rules={{ required: true }}
                                        name="category"
                                        control={control}
                                    />
                                    {errors.category && (
                                        <span className="fs-8 text-danger">
                                            Type Master Category is required
                                        </span>
                                    )}
                                </div> */}

                                <div className="col-lg-6 col-md-6 col-sm-12">
                                    <label className="form-label">
                                        Description
                                        <span className="fs-8 text-danger">
                                            {" "}
                                            *
                                        </span>
                                    </label>
                                    <textarea
                                        className="form-control"
                                        placeholder="Enter Description for type master"
                                        id="textarea-forms-description"
                                        {...register("description", {
                                            required: true,
                                        })}
                                    />
                                    {errors.description && (
                                        <span className="fs-8 text-danger">
                                            Description is required
                                        </span>
                                    )}
                                </div>

                                <div className="col-12">
                                    <div className="form-group">
                                        <button
                                            type="button"
                                            className="btn btn-md btn-light me-2"
                                            id="submit-button-backbutton"
                                            onClick={() => navigate(-1)}
                                        >
                                            Back
                                        </button>
                                        {isPending ? (
                                            <button
                                                type="button"
                                                id="button-typemaster-loading"
                                                className="btn btn-md text-dark"
                                                disabled
                                            >
                                                Loading...
                                            </button>
                                        ) : (
                                            <button
                                                type="submit"
                                                className="btn btn-md btn-primary"
                                                id="submit-button-create-typemaster"
                                            >
                                                Create
                                            </button>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CreateTypeMaster;
